import React, { useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faArrowUp,
  faArrowDown,
  faPen,
  faCalendarCheck,
  faUserCheck,
  faCheckSquare,
  faCheck,
  faCommentAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";

export default function ChecklistItem({
  item,
  editable,
  checkable,
  orderable,
  hasDoneComment,
  onToggle,
  onRemove,
  onUpdate,
  onMoveUp,
  onMoveDown,
  onSetComment

}) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(item.text);
  const [comment, setComment] = useState(item.doneComment);
  const [showPop, setShowPop] = useState(false);

  const save = () => {
    onUpdate(value);
    setEditing(false);
  };
  const saveComment = () => {
    onSetComment(comment);
    setShowPop(false);
  }
  const handleToggle = (e) => {
    const checked = e.target.checked;

    onToggle(e);

    if (checked && hasDoneComment) {
      setShowPop(true);
    } else {
      setShowPop(false);
    }
  };
  const popComment = (
    <Popover style={{ fontSize: "12px", fontFamily: "Vazir" }}>
      <Popover.Content>
        <div className="d-flex gap-2">
          <input className="form-control" onChange={(e) => setComment(e.target.value)} style={{ fontSize: "12px" }} />
          <Button variant="outline-success" style={{ padding: ".35rem .45rem" }}>
            <FontAwesomeIcon icon={faCheck} onClick={saveComment} />
          </Button>
        </div>

      </Popover.Content>
    </Popover>
  )
  return (
    <div className={`custom-checklist-item ${item.done ? "done" : ""}`}>
      <OverlayTrigger
        show={showPop}
        onToggle={setShowPop}
        overlay={popComment} trigger="click" rootClose placement="left">
        <input type="checkbox" className="form-check-input" checked={item.done} onChange={handleToggle} disabled={!checkable}/>
      </OverlayTrigger>
      {editing ? (
        <input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onBlur={save}
        />
      ) : (
        <span onDoubleClick={() => editable && setEditing(true)}>
          {item.text}
        </span>
      )}

      {editable && (
        <div className="actions">
          {orderable && (
            <>
              <FontAwesomeIcon icon={faArrowUp} color="purple" onClick={onMoveUp} />
              <FontAwesomeIcon icon={faArrowDown} color="blue" onClick={onMoveDown} />
            </>
          )}
          < FontAwesomeIcon icon={faPen} color="orange" onClick={() => setEditing(true)} />
          <FontAwesomeIcon icon={faTrash} color="#ff2600" onClick={onRemove} />
        </div>
      )}
      {item.doneDate && item.done &&
        <div className="footer">
          <div> <FontAwesomeIcon icon={faUserCheck} /> <label>{item.doneByName}</label></div>
          <div>  <FontAwesomeIcon icon={faCalendarCheck} /> <label>{item.doneDate}</label></div>
          {item.doneComment?.length > 0 &&
            <div style={{ position: "relative", cursor:"default" }} className="rightTooltip" data-tooltip={item.doneComment}>
              <FontAwesomeIcon icon={faCommentAlt} />&nbsp;یادداشت</div>}
        </div>
      }
    </div>
  );
}